import React from "react";
import { makeStyles, SvgIcon } from '@material-ui/core';
import { Row, Container, Col } from 'react-bootstrap';
import NotApproved from '../icons/notApproved.svg';
import './Ineligible.scss';
import IconHolder from "../../../Helpers/IconHolder";
import { useHistory } from "react-router-dom";

export default function Ineligible({ ineligibleProducts }) {
  const history = useHistory();

  const useStyles = makeStyles(theme => ({
    primaryColor: {
      color: theme.palette.primary.main,
    },
    PromotedProductBackgroundImage: {
      backgroundImage: "url(/Tools/perm_banner.jpg)",
    },
    PromotedProductBackgroundColor: {
      backgroundColor: `${theme.palette.primary.main}16`
    },
  }));

  const handleRedirect = (redirectPath) => {
    history.push(redirectPath);
  };

  const classes = useStyles();
  return (
    <Container className="ineligible-div">
      <Row className="justify-content-center mb-2">
        <IconHolder icon={NotApproved} viewBox="0 0 25 25" />
      </Row>
      <Row className="justify-content-center ">
        <h4 className="header-title">Your application was not approved.</h4>
      </Row>
      <Row className="justify-content-center">
        <Col md={5} sm={6} xs={8}>
          <h4 className="sub-header">Americo was unable to approve your application as applied - but that doesn’t mean you can’t get the coverage you need. Here’s some other options</h4>
        </Col>
      </Row>
      <div className="header-card mt-4">
        {ineligibleProducts.map((data, i) => {
          return (
            <Row className={`${i === 0 ? 'mt-2' : 'mt-3'} justify-content-center`} key={i}>
              <Col md={6} sm={7} xs={9}>
                <button
                  className={`promoted-product ${i === 0 ? classes.PromotedProductBackgroundImage + " has-bg-image" : classes.PromotedProductBackgroundColor}`}
                  onClick={() => handleRedirect(data.redirect)}>
                  <div className={`content-group`}>
                    <div className={`icon-container`}>
                      <SvgIcon component={data.icon} className={i === 0 ? 'white-text' : classes.primaryColor} />
                    </div>
                    <h3>{data.title}</h3>
                    <p>{data.subTitle}</p>
                  </div>
                  <span className={classes.primaryColor}>{data.buttonText}</span>
                </button>
              </Col>
            </Row>
          );
        })}
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/steps/Ineligible.js